$(function() {
    const formWrapper = document.getElementById('home-properties-search');
    if (!formWrapper) return;
    const form = formWrapper.querySelector('form');
    const radios = formWrapper.querySelectorAll('input[type="radio"]');
    const min_price = form.querySelector('#min_price');
    const max_price = form.querySelector('#max_price');

    const mobile = {};
    mobile.formWrapper = document.getElementById('home-properties-search-mobile');
    mobile.form = mobile.formWrapper.querySelector('form');
    mobile.radios = mobile.formWrapper.querySelectorAll('input[type="radio"]');
    mobile.min_price = mobile.form.querySelector('#min_price-mobile');
    mobile.max_price = mobile.form.querySelector('#max_price-mobile');

    [...radios].forEach(rad => {
        rad.addEventListener('change', ev => {
            // Set mobile radios to match
            mobile.formWrapper.querySelector(`input[name="buy_rent-mobile"][value="${buy_rent()}"]`).checked = true;
            mobile.formWrapper.querySelector(`input[name="res_comm-mobile"][value="${res_comm()}"]`).checked = true;
        })
    });

    [...mobile.radios].forEach(rad => {
        rad.addEventListener('change', ev => {
            // Set banner radios to match
            formWrapper.querySelector(`input[name="buy_rent"][value="${buy_rent(true)}"]`).checked = true;
            formWrapper.querySelector(`input[name="res_comm"][value="${res_comm(true)}"]`).checked = true;
        });
    });

    [...radios, ...mobile.radios].forEach(rad => {
        rad.addEventListener('change', ev => {
            form.setAttribute('action', `/properties/${buy_rent()}/${res_comm()}`);
            mobile.form.setAttribute('action', `/properties/${buy_rent()}/${res_comm()}`);

            updateSelectFields([min_price, mobile.min_price, max_price, mobile.max_price], buy_rent());
        });
    });

    const buy_rent = isMobile => __find_checked(`buy_rent${ isMobile ? '-mobile' : '' }`, isMobile || false).getAttribute('value');
    const res_comm = isMobile => __find_checked(`res_comm${ isMobile ? '-mobile' : '' }`, isMobile || false).getAttribute('value');
    const __find_checked = (name, isMobile) => [...(isMobile ? mobile.formWrapper : formWrapper).querySelectorAll(`input[name="${name}"]`)].find(rad => rad.checked);
});

function createOption(text, value) {
    const option = document.createElement('option');
    option.setAttribute('value', value);
    option.innerHTML = text;
    return option;
}

function updateSelectFields(selects, buy_rent) {
    const divisor = buy_rent === 'buy' ? [1, 1] : [250, 1000];
    const suffix = buy_rent === 'buy' ? '' : ' per week';
    selects.forEach(sel => {
        const label = sel.getAttribute('name') === 'min_price' ? 'No Minimum Price' : 'No Price Limit';
        while (sel.firstChild) sel.removeChild(sel.firstChild);
        sel.appendChild(createOption(label, '0'));

        for (let i = 5e4 / divisor[0]; i <= 2e6 / divisor[1]; i += 5e4 / divisor[0]) {
            sel.appendChild(createOption(`$${i.toLocaleString(undefined)}${suffix}`, i));
        }
    });
}
